import API from './API'
import {Deserialize} from "cerialize";
import Folder from "@/ts/interfaces/Folder";
import File from "@/ts/interfaces/File";
import Errors from "@/ts/interfaces/Errors";

export default class Templates extends API {

    static getTemplateStructure(pathSpecifier: string, packet_id: number): Promise<Folder> {
        return API.baseRequest("GET", `admin/templates/` + pathSpecifier + `/?packet_id=${packet_id}`, null).then(res => {
            return Deserialize(res, Folder)
        });
    }


    static createTemplateFolder(
        folderName: string,
        order_index: number | null,
        parent_folder_id: number | null,
        folder_type: string,
        file: any,
        demo_pdf_file: any | null,
        demo_video_url: string
    ): Promise<Folder | Errors> {
        let formData = new FormData();
        formData.append("name", folderName);
        if (order_index) {
            formData.append("order_index", order_index.toString());
        }
        if (parent_folder_id) {
            formData.append("parent_folder_id", parent_folder_id.toString());
        }
        formData.append("folder_type", folder_type);

        if (file && file.name) {
            formData.append("file", file);
            formData.append("filename", file.name);
        }

        if (demo_pdf_file && demo_pdf_file.name) {
            formData.append("demo_pdf_file", demo_pdf_file);
        }

        if (demo_video_url) {
            formData.append("demo_video_url", demo_video_url)
        }

        return API.upload(formData, "admin/templates/folder/", "POST").then(res => {
            return Deserialize(res, Folder)
        });
    }

    static updateTemplateFolder(
        folderId: number,
        name: string,
        order_index: number,
        demo_pdf_file: any | null,
        demo_video_url: string
    ): Promise<Folder> {
        let formData = new FormData();
        formData.append("name", name);
        formData.append("order_index", order_index.toString());

        if (demo_pdf_file && demo_pdf_file.name) {
            formData.append("demo_pdf_file", demo_pdf_file);
        }

        if (demo_video_url) {
            formData.append("demo_video_url", demo_video_url)
        }

        return API.upload(
            formData,
            `admin/templates/folder/${folderId}`,
            "PUT"
        ).then(res => {
            return Deserialize(res, Folder)
        });
    }

    static deleteTemplateFolder(folderId: number) {
        return API.baseRequest("DELETE", `admin/templates/folder/${folderId}`, {})
    }

    static createTemplateFile(filename: string, parent_folder_id: number, file: any): Promise<File | Errors> {
        let formData = new FormData();
        formData.append("filename", filename);
        formData.append("parent_folder_id", parent_folder_id.toString());
        formData.append("file", file);

        return API.upload(formData, "admin/templates/file/", "POST").then(res => {
            return Deserialize(res)
        })
    }

    static updateTemplateFile(fileId: number, filename: string, file: any): Promise<File | Errors> {
        let formData = new FormData();
        formData.append("filename", filename);
        formData.append("file", file);

        return API.upload(formData, `admin/templates/file/${fileId}`, "PUT").then(res => {
            return Deserialize(res)
        })
    }

    static getCloudFile(file_id: number): Promise<File> {
        return API.baseRequest("GET", `admin/templates/file/${file_id}`, null).then(res => {
            return Deserialize(res, File)
        });
    }

    static deleteTemplateFile(fileId: number) {
        return API.baseRequest("DELETE", `admin/templates/file/${fileId}`, {})
    }
}
